import Client from '../services/kenticoClient';
import { KENTICO_TYPES } from '../common/consts/kentico';

class CompaniesService {
  async getCompanyBySlug(slug) {
    const query = Client.items()
      .type(KENTICO_TYPES.COMPANY)
      .depthParameter(5)
      .equalsFilter('elements.slug', slug);

    return query.toPromise();
  }
}

export default new CompaniesService();



// WEBPACK FOOTER //
// ./src/services/Companies.service.js